// removed by extract-text-webpack-plugin
module.exports = {"root":"qempo_Card_root-2P75Aln","contentWrap":"qempo_Card_contentWrap-30NBy1p","titleContent":"qempo_Card_titleContent-2vWQt3S","imageWrap":"qempo_Card_imageWrap-1nd4YOW","titleWrap":"qempo_Card_titleWrap-1Eoejl7","title":"qempo_Card_title-1Rq5IKP","textBody":"qempo_Card_textBody-oaVa7Ai"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/home/elements/FeaturesCards/Card/Card.scss
// module id = 2221
// module chunks = 0